// @ts-nocheck
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import getLocalizedTime from "@insite/client-framework/Common/Utilities/getLocalizedTime";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadMessages from "@insite/client-framework/Store/Data/Messages/Handlers/LoadMessages";
import updateMessageIsRead from "@insite/client-framework/Store/Data/Messages/Handlers/UpdateMessageIsRead";
import { getMessagesDataView } from "@insite/client-framework/Store/Data/Messages/MessagesSelector";
import translate from "@insite/client-framework/Translate";
import { MessageModel } from "@insite/client-framework/Types/ApiModels";
import Accordion from "@insite/mobius/Accordion";
import { AccordionPresentationProps } from "@insite/mobius/Accordion/Accordion";
import { AccordionSectionPresentationProps, ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Radio, { RadioComponentProps } from "@insite/mobius/Radio";
// import RadioGroup, { RadioGroupComponentProps } from "@insite/mobius/RadioGroup"; // Starter Custom Code
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import FieldSetPresentationProps, { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import Heading, { HeadingPresentationProps } from "@store/Library/Components/Toolkit/Heading";
import LoadingOverlay, { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import RadioGroup, { RadioGroupProps } from "@store/MobiusOverrides/RadioGroup/RadioGroup";
import CardListHeading from "@store/Overrides/Components/CardListHeading";
import { boxStyles } from "@store/Themes/common/mixins/box";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { typographyGetNoResultsProps } from "@store/Themes/common/props/typography";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Starter Custom Code - End */

const messagesParameter = {};

const mapStateToProps = (state: ApplicationState) => ({
    messagesDataView: getMessagesDataView(state, messagesParameter),
    language: state.context.session.language,
});

const mapDispatchToProps = {
    updateMessageIsRead,
    loadMessages,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AccountMessagesStyles {
    centeringWrapper?: InjectableCss;
    messagesSection?: InjectableCss;
    messagesAccordion?: AccordionPresentationProps;
    messagesAccordionSection?: AccordionSectionPresentationProps;
    messagesGridContainer?: GridContainerProps;
    messageFilterGridItem?: GridItemProps;
    messageFilter?: MessageFilterStyles;
    messageCardGridItem?: GridItemProps;
    messageCard?: MessageCardStyles;
    noMessagesGridItem?: GridItemProps;
    noMessagesText?: TypographyPresentationProps;
    // Starter Custom Code
    loadingOverlay?: LoadingOverlayProps;
}

interface MessageFilterStyles {
    radioGroup?: RadioGroupProps; // Starter Custom Code
    radioButton?: FieldSetPresentationProps<RadioComponentProps>;
}

interface MessageCardStyles {
    article?: InjectableCss;
    gridContainer?: GridContainerProps;
    dateTimeGridItem?: GridItemProps;
    dateTimeText?: TypographyProps;
    subjectGridItem?: GridItemProps;
    subjectText?: TypographyProps;
    bodyGridItem?: GridItemProps;
    bodyText?: TypographyProps;
    actionButtonGridItem?: GridItemProps;
    actionButton?: ButtonPresentationProps;
    bottomBorderGridItem?: GridItemProps;
    bottomBorder?: InjectableCss;
    // Starter Custom Code
    heading?: HeadingPresentationProps;
    actionLink?: LinkPresentationProps;
}

export const accountMessagesStyles: AccountMessagesStyles = {
    loadingOverlay: { minHeight: 80 },
    messageFilter: {
        radioGroup: {
            horizontal: true,
        },
    },
    noMessagesText: typographyGetNoResultsProps(),
    messageCard: {
        article: {
            css: css`
                ${boxStyles(pxToRemArray([25]))}
                ${spacingStyles()}
            `,
        },
        heading: {
            forwardAs: "h3",
            verticalAlign: "top",
            extendedStyles: {
                title: {
                    css: css`
                        ${spacingStyles(null, pxToRem(10))}
                        padding-bottom: ${pxToRem(10)};
                        border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};

                        ${({ theme }) => css`
                            font-weight: ${theme.design.typography.weight.bold};
                            line-height: ${theme.design.typography.lineHeight.semi};
                        `}
                    `,
                },
                flexWrapper: {
                    verticalGap: pxToRem(2),
                    extendedStyles: {
                        content: {
                            css: css`
                                ${breakpoint("sm")} {
                                    flex-wrap: nowrap;
                                }
                            `,
                        },
                        item: {
                            css: css`
                                &:nth-child(2) {
                                    white-space: nowrap;

                                    ${breakpoint("xs", "down")} {
                                        width: 100%;
                                    }
                                }
                            `,
                        },
                    },
                },
            },
        },
        dateTimeText: {
            css: css`
                color: ${getColor("text.accent")};
                font-size: ${x => x.theme.design.typography.size.smallest};
                font-style: italic;
            `,
        },
        bodyText: {
            forwardAs: "p",
            css: css`
                ${spacingStyles(null, pxToRem(8))}
                color: ${getColor("text.accent")};
                font-size: ${x => x.theme.design.typography.size.small};
            `,
        },
        actionLink: {
            css: css`
                ${linkActionStyles()}
                display: flex;
            `,
        },
    },
};

function filterMessagesBasedOnFilterType(messages: MessageModel[], messagesFilterType: string): MessageModel[] {
    return messages.filter(message => {
        if (messagesFilterType === "All") {
            return true;
        }

        if (messagesFilterType === "Unread") {
            return !message.isRead;
        }

        return message.isRead;
    });
}

const styles = accountMessagesStyles;
const StyledSection = getStyledWrapper("section");
const StyledArticle = getStyledWrapper("article");

interface State {
    messagesFilterType: string;
    id?: string; // Starter Custom Code
}

class AccountMessages extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            messagesFilterType: "Unread", // Starter Custom Code
            id: uniqueId(), // Starter Custom Code
        };
    }

    componentDidMount() {
        if (!this.props.messagesDataView.value) {
            this.props.loadMessages(messagesParameter);
        }
    }

    render() {
        let title = "Messages";
        const { messagesDataView, updateMessageIsRead, language } = this.props;
        const { messagesFilterType } = this.state;
        const messages = messagesDataView.value ? messagesDataView.value : [];

        if (messagesDataView.value) {
            const countUnreadMessages = messages.filter(message => !message.isRead).length;
            title = `Messages (${countUnreadMessages})`;
        }

        const filteredMessages = filterMessagesBasedOnFilterType(messages, messagesFilterType);
        const componentStyles: MessageFilterStyles = styles.messageFilter || {};

        /* Starter Custom Code - Start */
        const hasNoResults = filteredMessages.length === 0;
        const cardListHeadingId = `${this.state.id}-cardListlabel`;
        const allRadioLabelId = `${this.state.id}-allMessageLabel`; // Foundation Custom Code
        const unreadRadioLabelId = `${this.state.id}-unreadMessageLabel`;
        const readRadioLabelId = `${this.state.id}-readMessageLabel`;

        return (
            <StyledSection {...styles.messagesSection} data-test-selector="myAccountMessagesSection">
                <CardListHeading heading={title} hasNoResults={hasNoResults} id={cardListHeadingId}>
                    {messagesDataView.value && (
                        <RadioGroup
                            as="legend" // Foundation Custom Code
                            {...componentStyles.radioGroup}
                            value={messagesFilterType}
                            onChangeHandler={(event: any) => this.setState({ messagesFilterType: event.target.value })}
                            labelId={cardListHeadingId}
                        >
                            {/* Foundation Custom Code - Start */}
                            <Radio
                                {...componentStyles.radioButton}
                                key="All"
                                aria-labelledby={allRadioLabelId}
                                value={translate("All")}
                            >
                                {translate("All")}
                            </Radio>

                            <Radio
                                {...componentStyles.radioButton}
                                key="Unread"
                                aria-labelledby={unreadRadioLabelId}
                                value={translate("Unread")}
                            >
                                {translate("Unread")}
                            </Radio>

                            <Radio
                                {...componentStyles.radioButton}
                                key="Read"
                                aria-labelledby={readRadioLabelId}
                                value={translate("Read")}
                            >
                                {translate("Read")}
                            </Radio>
                            {/* Foundation Custom Code - End */}
                        </RadioGroup>
                    )}
                </CardListHeading>
                <LoadingOverlay {...styles.loadingOverlay} loading={messagesDataView.isLoading}>
                    {messagesDataView.value &&
                        (hasNoResults ? (
                            <Typography {...styles.noMessagesText}>{translate("No messages")}</Typography>
                        ) : (
                            filteredMessages.map(message => (
                                <MessageCard
                                    key={message.id}
                                    message={message}
                                    updateMessageIsRead={updateMessageIsRead}
                                    language={language}
                                />
                            ))
                        ))}
                </LoadingOverlay>
            </StyledSection>
        );
        /* Starter Custom Code - End */
    }
}

type MessageCardProps = {
    message: MessageModel;
} & Pick<Props, "updateMessageIsRead" | "language">;

const MessageCard = ({ message, language, updateMessageIsRead }: MessageCardProps) => {
    const handleClickMessageReadStatus = () =>
        updateMessageIsRead({
            message,
            isRead: !message.isRead,
        });

    const dateDisplay = getLocalizedDateTime({
        dateTime: message.dateToDisplay,
        language,
        options: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        },
    });
    const timeDisplay = getLocalizedTime({
        dateTime: message.dateToDisplay,
        language,
        options: {
            hour: "numeric",
            minute: "numeric",
        },
    });
    const componentStyles: MessageCardStyles = styles.messageCard || {};

    /* Starter Custom Code - Start */
    return (
        <StyledArticle {...componentStyles.article}>
            <Heading title={message.subject} {...componentStyles.heading}>
                {message.dateToDisplay && (
                    <Typography {...componentStyles.dateTimeText}>
                        {dateDisplay}&nbsp;{timeDisplay}
                    </Typography>
                )}
            </Heading>
            <Typography {...componentStyles.bodyText}>{message.body}</Typography>
            <Link {...componentStyles.actionLink} onClick={handleClickMessageReadStatus}>
                {message.isRead ? translate("Mark as Unread") : translate("Mark as Read")}
            </Link>
        </StyledArticle>
    );
    /* Starter Custom Code - End */
};

/* Starter Custom Code - Start */
const accountMessages: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AccountMessages),
    definition: {
        displayName: "Messages",
        allowedContexts: ["MyAccountPage"],
        group: "My Account",
    },
};

export default accountMessages;
/* Starter Custom Code - End */
